import { useFindState } from "@/definitions/hooks/useFindState";
import LineChart from "@/features/pain-watch/diary/components/LineChart";
import { services as s } from "@/services";
import { useEffect, useState } from "react";

import { processInjection } from "./services/processInjection";

import type { DiaryT } from "./content/exampleDiaries";
interface Props {
	diary: DiaryT;
}
const DiaryRecord = ({ diary }: Props) => {
	const [data, setData] = useState<number[]>([]);
	const [labels, setLabels] = useState<string[]>([]);

	const { findState } = useFindState();

	useEffect(() => {
		setData(diary?.entries?.map((entry) => entry?.value));
		setLabels(diary?.entries?.map((entry) => entry?.entry_td_friendly));
	}, [diary]);

	return (
		<section className="w-full">
			{diary?.current_state && (
				<div className="">
					<section className="bg-white shadow-md p-4 border border-slate-300 rounded-xl max-w-[800px]">
						<div>
							<div className="flex flex-col gap-y-2 mb-4">
								<div className="flex justify-between items-start w-full">
									<div className="flex items-center gap-x-2 [&_svg]:w-[32px] [&_svg]:h-[32px]">
										<div data-tip={[diary.current_state]} data-for="state-icon">
											{findState(diary?.current_state)?.icon}
										</div>
										<h2 className="text-slate-700 text-2xl">
											{findState(diary.current_state)?.name ??
												"State Name Missing"}
										</h2>
									</div>
									<b className="bg-indigo-200 px-3 py-1 rounded-md font-medium text-indigo-700 text-lg capitalize">
										{diary.hospital_name}
									</b>
								</div>
								<hr />
								<div className="flex justify-between items-start w-full">
									<h3 className="font-medium text-slate-700 text-xl">
										{diary.patient_name}
									</h3>
									<h4 className="font-semibold text-md text-slate-900">
										{diary.patient_hospital_number}
									</h4>
								</div>
								<h6 className="font-medium text-md text-slate-500">
									{s.time.formatDate(diary.inj_date)}
								</h6>
								<h5 className="font-regular text-md text-slate-900">
									{processInjection(diary)}
								</h5>
							</div>

							<div className="flex justify-center items-center mx-auto my-2 border-lg w-full h-full">
								{data?.length > 0 ? (
									<LineChart
										data={{
											labels: labels,
											datasets: [
												{
													label: "Pain Score",
													data: data,
													backgroundColor: "#fbffff",
													borderColor: "lightblue",
													fill: false,
													tension: 0.4,
												},
											],
										}}
									/>
								) : (
									<h4>No Pain Scores Logged</h4>
								)}
							</div>
							<div className="flex justify-center items-center mx-auto my-2 max-w-[600px] font-normal text-slate-500">
								<i>
									{diary?.entries[0] &&
										`Last logged
               ${s.time.toNow(
									s.time.findEarliest(diary.entries, "entry_time")?.entry_time,
								)}`}
								</i>
							</div>
						</div>
					</section>
				</div>
			)}
		</section>
	);
};

export default DiaryRecord;
